// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__RD4au","colCheckbox":"styles_colCheckbox__yqBuk"};